<style src="./SuggestLab.scss" lang="scss" scoped></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    @blur="blur"
    :rules="rules"
    v-model="inputValue"
    min="2">

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="short-name">{{ item.lab }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import { InputSuggest, InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { SearchLabByName } from '@/brain/record/lab'

export default {
  name: 'SuggestClient',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem
  },
  data () {
    return {
      captionRaw: 'lab'
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    doSearch (pSearchTerm) {
      return SearchLabByName({ labName: pSearchTerm })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/suggest-lab/SuggestLab.vue